module.exports = __webpack_public_path__ + "img/green1.242c735b.png";